module.exports = __webpack_public_path__ + "media/packs/common/assets/images/mimamori/mimamori_o-6c3198f00342341ca3b2b16627e0a605.png";